import { useQuery } from '@tanstack/react-query'
import { getQueue } from '@/lib/api/queue'

/** Dropship Queue data. Server pre-sorts newest first; we render in that order. */
export function useQueue() {
  return useQuery({
    queryKey: ['queue'],
    queryFn: getQueue,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  })
}
